import { numberToCurrency } from "../../helpers/functions";
import PaginationControls from "../../components/Pagination";
import EyeIcon from "../../components/EyeIcon";
import TableSearch from "../../components/TableSearch";

const List = ({
  data,
  page,
  limit,
  count,
  searchValue,
  onView = () => {},
  onSearch = () => {},
  onPageChange = () => {},
}) => {
  return (
    <div className="list-container">
      <div className="card d-none d-md-table w-100">
        <div className="card-body">
          <TableSearch value={searchValue} onChange={onSearch} />
          <div className="table-responsive w-100">
            <table className="table d-none d-md-table table-bordered border-light" id="payments">
              <thead className="table-light">
                <tr>
                  <th className="border-end">#</th>
                  <th className="border-end">Name</th>
                  <th className="border-end">Mobile</th>
                  <th className="border-end">Total Amount</th>
                  <th className="border-end">Due Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="border-end text-center text-nowrap">
                      {(page - 1) * limit + index + 1}
                    </td>
                    <td className="border-end">{item.name || ""}</td>
                    <td className="border-end">{item.mobile || ""}</td>
                    <td className="border-end text-end text-nowrap">
                      {numberToCurrency(item.total)}
                    </td>
                    <td
                      className={`border-end text-end text-nowrap ${
                        item.dueAmount > 0 ? "text-danger" : "text-success"
                      }`}
                    >
                      {numberToCurrency(item.dueAmount)}
                    </td>
                    <td>
                      <div className="d-flex gap-2 justify-content-center">
                        <EyeIcon onClick={() => onView({ show: true, id: item._id })} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <PaginationControls page={page} count={count} limit={limit} onChange={onPageChange} />
        </div>
      </div>
      <div className="d-md-none w-100">
        {data.map((item) => (
          <div key={item.id} className="card shadow-sm mb-3">
            <div className="card-body">
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <small className="text-muted">Name</small>
                  <p className="mb-0 fw-medium">{item.name}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Mobile</small>
                  <p className="mb-0">{item.mobile}</p>
                </div>
              </div>
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <small className="text-muted">Total Amount</small>
                  <p className="mb-0 fw-bold">{numberToCurrency(item.total)}</p>
                </div>
                <div className="col-6">
                  <small className="text-muted">Due Amount</small>
                  <p className={`mb-0 ${item.dueAmount > 0 ? "text-danger" : "text-success"}`}>
                    {numberToCurrency(item.dueAmount)}
                  </p>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-2">
                <EyeIcon
                  size="sm"
                  onClick={() => onView({ show: true, id: item._id })}
                  className="btn-icon"
                />
              </div>
            </div>
          </div>
        ))}
        <div className="mb-3">
          <PaginationControls page={page} count={count} limit={limit} onChange={onPageChange} />
        </div>
      </div>
    </div>
  );
};

export default List;
